<form class="full-size-block" [formGroup]="form_group" [title]="  label |translate ">
    <ng-container *ngIf="!design_pattern || design_pattern==1">
        <label *ngIf="label_block&&label" class="m-0 html-label" [ngClass]="{'req':mandatory}"
            [innerHtml]="label | HTMLFormatter |translate"></label>
        <mat-form-field #hidden_input id="{{random_id}}" [ngClass]="label_class && label_class!='' ?label_class:''"
            [appearance]="appearance"
            [ngClass]="{'no-label':hide_label, 'label-overflow': label_overflow,'read-only':readonly,'default-read-only':default_readonly}"
            *ngIf="!basic " style="margin-bottom : 0px;" [floatLabel]="float_label?float_label:'always'">
            <mat-label *ngIf=" !label_block&&mandatory&&label" [ngClass]="{'req': show_mandatory}"
                [innerHtml]="label | HTMLFormatter |translate">
            </mat-label>
            <mat-label *ngIf="!label_block&&!mandatory&&label" [innerHtml]="label | HTMLFormatter |translate">
            </mat-label>
            <input style="display: none;" type="text" autocomplete="off"
                [placeholder]="placeholder || '<- - '+ ('TM-SELECT.select' |translate)+' - ->' " matInput
                [formControl]="form_group.get([form_control])">
            <span matPrefix *ngIf="prefix_label" class="prefix">{{prefix_label}}&nbsp;</span>
            <input title="{{search.value}}" class="pr-1" style="z-index: 1001;" type="text" autocomplete="off"
                [ngClass]="input_class" [readonly]="readonly" [placeholder]="placeholder || '<- - Select - ->'  "
                (keydown)="checkForTab($event)" (click)="showList($event)" (keyup)="searchKeyPress($event)" matInput
                [formControl]="search">
            <!-- (focusin)="wait_till_content_loading ?showList($event): ''" -->
            <i class="fa fa-close mr-2 x" matSuffix (click)="clearValue($event)"
                *ngIf="!mandatory && !disabled && !readonly && form_group.get(form_control).value"
                style="cursor: pointer;"></i>
            <i *ngIf="!disabled &&!auto_addition && !readonly" (click)="showList($event)" class="fa fa-angle-down"
                matSuffix></i>
            <!-- <span matSuffix *ngIf="suffix_label" class="suffix">&nbsp;{{suffix_label}}</span> -->

            <div matSuffix class="btn ml-2 btn-sm js-btn-save pointer" style="margin-top: -7px;"
                [title]="'Create New/Modify'" *ngIf="(addFunc || suffix_btn_icon) && !disabled && !readonly"
                (click)="suffixButtonClicked()">
                <i class="fa {{suffix_btn_icon}}"></i>
            </div>
            <span matSuffix class="btn ml-2 btn-sm js-btn-save pointer" style="margin-top: -7px;"
                [title]="secondary_suffix_title" *ngIf="addFunc && !disabled && secondary_suffix_btn"
                (click)="suffixButtonClicked(2)">
                <i class="fa {{secondary_suffix_btn}}"></i>
            </span>
            <!-- <i [ngClass]="suffix_btn_icon" class="fa {{suffix_btn_icon}}  ml-2 pointer primary" matSuffix style="    font-size: 18px;
          border: 1px solid;
          padding: 5px;
          border-radius: 5px;
          background: var(--tallite-primary);
          color: white !important;" *ngIf="suffix_btn_icon" (click)="suffixButtonClicked()"
          [matTooltip]="suffix_btn_label"></i> -->
            <!-- <button class="btn btn-sm ml-2 js-btn-save tm-adion pointer" matSuffix *ngIf="suffix_btn_label &&!suffix_btn_icon"
          (click)="suffixButtonClicked()">
          {{suffix_btn_label}}
        </button> -->
            <mat-error *ngIf="form_group.get([form_control]).hasError('required');else maxlength">
                Field is mandatory
                <!-- <span [innerHTML]="label + ' is mandatory'"></span> -->
            </mat-error>
            <ng-template #maxlength>
                <mat-error *ngIf="form_group.get([form_control]).hasError('maxlength');else minlength">
                    Maximum length ({{maxLength}}) has exceeded
                </mat-error>
            </ng-template>
            <ng-template #minlength>
                <mat-error *ngIf="form_group.get([form_control]).hasError('minlength');else maxvalue">
                    Minimum length must be {{minLength}} digits
                </mat-error>
            </ng-template>
            <ng-template #maxvalue>
                <mat-error *ngIf="form_group.get([form_control]).hasError('max');else minvalue">
                    Value must be lesser than {{maxValue}}
                </mat-error>
            </ng-template>
            <ng-template #minvalue>
                <mat-error *ngIf="form_group.get([form_control]).hasError('min')">
                    Value must be greater than {{minValue}}
                </mat-error>
            </ng-template>
        </mat-form-field>
        <div class="input-group" *ngIf="basic">
            <input type="text" [ngStyle]="style" autocomplete="off" title="{{placeholder}}"
                placeholder="{{placeholder}}" [formControl]="search" #text (keydown)="searchKeyPress($event)"
                (keyup)="searchKeyPress($event)">
            <div class="input-group-append my-auto p-1">
                <i class="fa fa-times" matSuffix></i>
                <i class="fa fa-angle-down" matSuffix></i>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="design_pattern==2">

        <div [ngClass]="{'has-error': form_group && form_group.get([form_control]) && (form_group.get([form_control]).hasError('required')||form_group.get([form_control]).hasError('maxlength')||
      form_group.get([form_control]).hasError('minlength') ||form_group.get([form_control]).hasError('max')
      ||form_group.get([form_control]).hasError('min') || form_group.get([form_control]).hasError('pattern')) ,
      'has-success':  form_group && form_group.get([form_control]) && (!form_group.get([form_control]).hasError('required') && !form_group.get([form_control]).hasError('maxlength')&&
      !form_group.get([form_control]).hasError('minlength') && !form_group.get([form_control]).hasError('max')
      &&!form_group.get([form_control]).hasError('min') && !form_group.get([form_control]).hasError('pattern')) }"
            id="{{random_id}}" style="max-width: 100%; width: 100%;">
            <label class="design-2-label" [ngClass]="{'req':mandatory}" [innerHtml]="label " *ngIf="label"></label>
            <input style="display: none;" type="text" autocomplete="off" placeholder="{{placeholder}}"
                [formControl]="form_group.get([form_control])" [maxLength]="500">

            <!-- <i class="fa fa-close mr-2 x" matSuffix (click)="clearValue($event)"
              *ngIf="!mandatory && form_group.get(form_control).value" style="cursor: pointer;"></i>
          <i (click)="showList($event)" class="fa fa-angle-down" matSuffix></i> -->
            <div [ngClass]="{'input-group':true}" [matTooltip]="toolTip || ''">
                <input title="{{search.value}}" class="pr-1 form-control" [maxLength]="500"
                    style="border: 1px solid #ced4da; border-right: 0;padding: .375rem .75rem;font-size: 13px;"
                    type="text" autocomplete="off" placeholder="{{placeholder}}" (keydown)="checkForTab($event)"
                    (focusin)="showList($event);" (click)="showList($event)" (keyup)="searchKeyPress($event)"
                    [formControl]="search">

                <div class="input-group-append" style="background-color: white; border-radius: 5px;font-size: 13px;">
                    <span class="input-group-text back" id="basic-addon1">
                        <i (click)="clearValue($event)" class="fa fa-times"
                            *ngIf="!mandatory && form_group.get(form_control).value"></i>
                        <i (click)="showList($event)" class="fa fa-angle-down ml-1"></i>
                    </span>
                </div>

                <div class="input-group-append" style="background-color: white; border-radius: 5px;font-size: 13px;"
                    *ngIf="addFunc">
                    <span class="input-group-text" id="basic-addon2">
                        <i class="fa fa-plus" (click)="addFunc()"></i>
                    </span>
                </div>
            </div>
            <!-- <div class="input-group">
              <input type="text" class="form-control" placeholder="Amount ">
              <div class="input-group-append">
                  <span class="input-group-text">.040</span>
              </div>
          </div> -->
            <!-- <mat-error *ngIf="form.get([form_control]).hasError('required');else maxlength">
          Field is mandatory
      </mat-error>
      <ng-template #maxlength>
          <mat-error *ngIf="form.get([form_control]).hasError('maxlength');else minlength">
              Maximum length ({{maxLength}}) has exceeded
          </mat-error>
      </ng-template>
      <ng-template #minlength>
          <mat-error *ngIf="form.get([form_control]).hasError('minlength');else maxvalue">
              Minimum length must be {{minLength}} digits
          </mat-error>
      </ng-template>
      <ng-template #maxvalue>
          <mat-error *ngIf="form.get([form_control]).hasError('max');else minvalue">
              Value must be lesser than {{maxValue}}
          </mat-error>
      </ng-template>
      <ng-template #minvalue>
          <mat-error *ngIf="form.get([form_control]).hasError('min'); else pattern">
              Value must be greater than {{minValue}}
          </mat-error>
      </ng-template>
      <ng-template #pattern>
          <mat-error *ngIf="form.get([form_control]).hasError('pattern')">
              {{pattern_desc || 'Invalid input'}}
          </mat-error>
      </ng-template> -->
        </div>
    </ng-container>
    <ng-container *ngIf=" design_pattern==4">
        <label *ngIf="label_block&&label" class="m-0 html-label" [ngClass]="{'req':mandatory}"
            [innerHtml]="label | HTMLFormatter |translate"></label>
        <mat-form-field #hidden_input id="{{random_id}}" [ngClass]="label_class && label_class!='' ?label_class:''"
            [ngClass]="{'no-label':hide_label, 'label-overflow': label_overflow,'read-only':readonly}" *ngIf="!basic "
            style="margin-bottom : 0px;" [floatLabel]="(float_label || appearance) ?( float_label || 'none') :'always'"
            [appearance]="appearance">
            <mat-label [ngClass]="{'enable-label-action':label_action_type}" *ngIf="!label_block&&label">
                {{label |translate}}
                <ng-container *ngIf="label_action_type==1  ">
                    <span>
                        ( {{label_action_title}}
                        <span class="link" (click)="suffixButtonClicked(99)">
                            {{'TM-SELECT.clickHere'|translate}}
                        </span>
                        )
                    </span>
                </ng-container>

            </mat-label>
            <input style="display: none;" type="text" autocomplete="off"
                [placeholder]="placeholder || '<- - '+ ('TM-SELECT.select' |translate)+' - ->' " matInput
                [formControl]="form_group.get([form_control])">

            <span matPrefix *ngIf="prefix_label" class="prefix">{{prefix_label}}&nbsp;</span>
            <input title="{{search.value}}" class="pr-1" style="z-index: 1001;" type="text" autocomplete="off"
                [readonly]="readonly" [placeholder]="placeholder || '<- - Select - ->'  "
                (keydown)="checkForTab($event)" (focusin)="showList($event);" (click)="showList($event)"
                (keyup)="searchKeyPress($event)" matInput [formControl]="search">

            <i class="fa fa-close mr-2 x" matSuffix (click)="clearValue($event)"
                *ngIf="!mandatory && !disabled && !readonly && form_group.get(form_control).value"
                style="cursor: pointer;"></i>
            <i *ngIf="!disabled &&!auto_addition && !readonly" (click)="showList($event)" class="fa fa-angle-down"
                matSuffix></i>
            <!-- <span matSuffix *ngIf="suffix_label" class="suffix">&nbsp;{{suffix_label}}</span> -->

            <div matSuffix class="btn ml-2 btn-sm js-btn-save pointer" style="margin-top: -7px;"
                *ngIf="(addFunc || suffix_btn_icon) && !disabled && !readonly" (click)="suffixButtonClicked(100)">
                <i class="fa {{suffix_btn_icon}}"></i>
            </div>
            <!-- <i [ngClass]="suffix_btn_icon" class="fa {{suffix_btn_icon}}  ml-2 pointer primary" matSuffix style="    font-size: 18px;
          border: 1px solid;
          padding: 5px;
          border-radius: 5px;
          background: var(--tallite-primary);
          color: white !important;" *ngIf="suffix_btn_icon" (click)="suffixButtonClicked()"
          [matTooltip]="suffix_btn_label"></i> -->
            <!-- <button class="btn btn-sm ml-2 js-btn-save tm-adion pointer" matSuffix *ngIf="suffix_btn_label &&!suffix_btn_icon"
          (click)="suffixButtonClicked()">
          {{suffix_btn_label}}
        </button> -->
            <mat-error *ngIf="form_group.get([form_control]).hasError('required');else maxlength">
                Field is mandatory
                <!-- <span [innerHTML]="label + ' is mandatory'"></span> -->
            </mat-error>
            <ng-template #maxlength>
                <mat-error *ngIf="form_group.get([form_control]).hasError('maxlength');else minlength">
                    Maximum length ({{maxLength}}) has exceeded
                </mat-error>
            </ng-template>
            <ng-template #minlength>
                <mat-error *ngIf="form_group.get([form_control]).hasError('minlength');else maxvalue">
                    Minimum length must be {{minLength}} digits
                </mat-error>
            </ng-template>
            <ng-template #maxvalue>
                <mat-error *ngIf="form_group.get([form_control]).hasError('max');else minvalue">
                    Value must be lesser than {{maxValue}}
                </mat-error>
            </ng-template>
            <ng-template #minvalue>
                <mat-error *ngIf="form_group.get([form_control]).hasError('min')">
                    Value must be greater than {{minValue}}
                </mat-error>
            </ng-template>
        </mat-form-field>
        <div class="input-group" *ngIf="basic">
            <input type="text" [ngStyle]="style" autocomplete="off" title="{{placeholder}}"
                placeholder="{{placeholder}}" [formControl]="search" #text (keydown)="searchKeyPress($event)"
                (keyup)="searchKeyPress($event)">
            <div class="input-group-append my-auto p-1">
                <i class="fa fa-times" matSuffix></i>
                <i class="fa fa-angle-down" matSuffix></i>
            </div>
        </div>
    </ng-container>


    <!-- <cdk-virtual-scroll-viewport #options_list_view
      style="z-index:1001;opacity: 1; pointer-events: auto;color: black;position:fixed;background-color: white;top: 45px;"
      [style.width.px]="container_width" *ngIf="show_list && (auto_addition &&filtered_options.length==0?false:true)"
      itemSize="40" class="viewport select-menu tm-select-menu" (scrolledIndexChange)="getNextBatch($event);"
      [style.left.px]="left" [style.top.px]="top">
      <ng-container *cdkVirtualFor="let option of (filtered_options); let i = index">
        <li class="select-options" (click)="onSelect(option,i)" [class.active]="i == arrow_key_location"
          [value]="option[id_property]">
          <ng-container *ngIf="!translate_options">
            {{ option[title_property] }}
          </ng-container>
          <ng-container *ngIf="translate_options">
            {{ option[title_property] |translate }}
          </ng-container>
          <span class="float-right" *ngIf="option.suffixTemplate"
            [innerHTML]="option.suffixTemplate |TMsafeHTML : 'html'  ">
          </span>
        </li>
      </ng-container>
      <li *ngIf="filtered_options == null || filtered_options == undefined || filtered_options.length == 0 "
        class="select-options"> No data found!</li>
    </cdk-virtual-scroll-viewport>
  
    <div id="overlay_mat_select_search" (click)="hideList()" *ngIf="display_overlay"
      style="position: fixed;width: 100%;height: 100%;z-index: 1000;left: 0;top: 0;">
    </div> -->
</form>